import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    useSuspense: true,
    lng: 'ar',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          description: {
            part1: 'Edit <1>src/App.js</1> and save to reload.',
            part2: 'Learn React',
          },
        },
      },
      de: {
        translation: {
          description: {
            part1: 'Andere <1>src/App.js</1> und speichere um neu zu laden.',
            part2: 'Lerne React',
          },
        },
      },
      ar: {
        translation: {
          description: {
            part1: 'ثثثثثثثثثثثث',
            part2: 'ثثثثثثثثثثثث',
          },
        },
      },
    },
  });

export default i18n;
